<div class="search-bar">
	<mat-form-field>
		<mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }}</mat-label>
		<input #searchInput (keydown)="isEnter($event)" matInput/>
	</mat-form-field>
	<div class="search-button">
		<button (click)="search()" class="vinavonButton" mat-mini-fab style="background-color: #ffffff;">
			<mat-icon>search</mat-icon>
		</button>
	</div>
	<div class="filter-button">
		<button (click)="openFilter()" class="vinavonButton" mat-mini-fab style="background-color: #ffffff;">
			<mat-icon>filter_alt</mat-icon>
		</button>
	</div>
</div>
<div style="position:relative">
	<div #filterOptions class="filter-options">
		<mat-form-field>
			<mat-label>Objekt</mat-label>
			<input (keydown)="isEnter($event)" [formControl]="note4Control" matInput type="text">
		</mat-form-field>
		<mat-form-field>
			<mat-label>Status</mat-label>
			<mat-select [formControl]="objStatusControl" multiple>
				<mat-select-trigger>
					<ng-container *ngIf="objStatusControl.value && objStatusControl.value.length > 0">
						{{ objStatusControl.value[0].description }}
					</ng-container>
					<span *ngIf="(objStatusControl.value?.length || 0) > 1">
						(+{{ (objStatusControl.value.length || 0) - 1 }} {{ 2 == objStatusControl.value.length ? 'Anderer' : 'Andere' }})
					</span>
				</mat-select-trigger>
				<mat-option *ngFor="let status of statusFilterOptions()" [value]="status">{{ status.description }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Projektleiter</mat-label>
			<mat-select [formControl]="projectLeaderControl" multiple>
				<mat-select-trigger>
					<ng-container *ngIf="projectLeaderControl.value && projectLeaderControl.value.length > 0">
						{{ projectLeaderControl.value[0].bezeichnung }}
					</ng-container>
					<span *ngIf="(projectLeaderControl.value?.length || 0) > 1">
						(+{{ (projectLeaderControl.value.length || 0) - 1 }} {{ 2 == projectLeaderControl.value.length ? 'Weiter' : 'Weitere' }})
					</span>
				</mat-select-trigger>
				<mat-option *ngFor="let pl of projectLeaderFilterOptions()" [value]="pl">{{ pl.bezeichnung }}</mat-option>
			</mat-select>
		</mat-form-field>
		
		<mat-form-field>
			<mat-label>Ort</mat-label>
			<mat-select [formControl]="placeControl" multiple>
				<mat-select-trigger>
					<ng-container *ngIf="placeControl.value && placeControl.value.length > 0">
						{{ placeControl.value[0].town }}
					</ng-container>
					<span *ngIf="(placeControl.value?.length || 0) > 1">
						(+{{ (placeControl.value.length || 0) - 1 }} {{ 2 === placeControl.value.length ? 'Weiter' : 'Weitere' }})
					</span>
				</mat-select-trigger>
				<mat-option *ngFor="let city of placesFilterOptions()" [value]="city">{{ city.town }}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div>

<div class="search-area">
	<div class="search-result-list">
		<ng-container *ngIf="searchResults()?.length; else noResult">
			<ng-container *ngFor="let result of searchResults(); let i = index;">
				<div (click)="onObjectSelected(result)" class="row">
					<div [style.background-image]="'url(' + result.imageURL + ')'" class="image"></div>
					<div class="object-id">{{ result.objectNr }}</div>
					<div class="object-name">{{ result.description }}</div>
				</div>
			</ng-container>
		</ng-container>
		<ng-template #noResult>
			<ng-container *ngIf="(hasSearched | async); else helpText">
				<span>{{ 'MAIN_APP_OBJECTS.searchNotFound' | translate }}</span>
			</ng-container>
		</ng-template>
		<ng-template #helpText>
			<span>{{ 'MAIN_APP_OBJECTS.searchHelpText' | translate }}</span>
		</ng-template>
	</div>
</div>

